// Device-side position in the oldest-first For-You cycle. Each post's
// "created_at|post_id" key is its unique number; we remember the latest one watched.
// `gen` counts cycle wrap-arounds this session so a new cycle's (smaller) keys win.
const KEY = "tain-feed-pos-v1";
let storedGen = 0;

export const feedKey = (p) => `${p.created_at}|${p.post_id}`;

export const feedPosition = {
  get: () => localStorage.getItem(KEY) || null,
  markSeen(key, gen = 0) {
    const cur = localStorage.getItem(KEY);
    if (gen > storedGen || !cur || (gen === storedGen && key > cur)) {
      storedGen = Math.max(storedGen, gen);
      localStorage.setItem(KEY, key);
    }
  },
};
